<template>
  <div v-if="visible" id="tab-hbl">
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-dropdown
            no="1"
            :class="readonly?'not-click':''"
            split-button
            type="primary"
            @click="commandHandle(command1)"
            @command="p=>{command1=p;commandHandle(command1)}"
          >
            {{ command1 }}
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="$t('SeaExport.CodeSearching')">{{ $t('SeaExport.CodeSearching') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromTheLastTime')">{{ $t('SeaExport.CopyFromTheLastTime') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyFromOtherBill')">{{ $t('SeaExport.CopyFromOtherBill') }}</el-dropdown-item>
              <el-dropdown-item :command="$t('SeaExport.CopyCargoDescriptionAndMarks')">{{ $t('SeaExport.CopyCargoDescriptionAndMarks') }}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            v-show="Boolean(form.uuid)"
            no="2"
            :disabled="btnPrintDisabled"
            type="primary"
            @click="originalPrint"
          >{{ form.releaseType === 1 ? $t('SeaExport.PrintTheOriginalBl') : $t('SeaExport.TelexRelease') }}</el-button>
          <el-button
            v-show="readonly&&form.state==2"
            no="3"
            type="primary"
            @click="pm.onSubmitStateEvent()"
          >{{ $t('SeaExport.Unlock') }}</el-button>
          <el-button
            no="4"
            :disabled="readonly||!form.uuid"
            type="primary"
            @click="showAddressFormatDialog"
          >{{ $t('SeaExport.AntiTerroristFormattedAddress') }}</el-button>
          <el-checkbox v-model="form.oversea" no="5" :disabled="readonly" style="margin-left: 10px;">{{ $t('SeaExport.BlBeReleased') }}</el-checkbox>
          <!--          <el-checkbox-->
          <!--            v-model="form.printParam1"-->
          <!--            :disabled="readonly"-->
          <!--            @change="pm.changeSeaeq()"-->
          <!--          >Part of</el-checkbox>-->
          <el-checkbox v-model="form.printParam2" no="6" :disabled="readonly" style="margin-left: -20px;">{{ $t('SeaExport.ClauseOfNoWoodPackingMaterial') }}</el-checkbox>
          <!--          <el-checkbox-->
          <!--            v-model="form.printParam3"-->
          <!--            :disabled="readonly"-->
          <!--            @change="val=>{pm.changeContainer(val)}"-->
          <!--          >箱封号后跟件数毛重体积</el-checkbox>-->
          <el-checkbox v-model="form.chkConsolidationClosed" no="7" :disabled="readonly" style="margin-left: -20px;" @change="pm.changeAfrAddress()">{{ $t('SeaExport.AFRTheLastBill') }}</el-checkbox>
        </div>
      </div>
    </div>
    <div style="display: flex">
      <div class="section form-column">
        <el-form label-width="70px" label-position="right" style="height:100%">
          <span class="title">{{ $t('SeaExport.ConsigneeShipperAndNotifyInfo') }}</span>
          <el-form-item :label="$t('Message.Shipper')" class="custom">
            <div style="display: flex;">
              <el-input v-model="form.shipperCode" :disabled="readonly" no="8" style="width:157px;flex: 1" />
              <el-button no="9" :disabled="readonly" type="primary" style="margin-left: 5px" @click="clearSenderAndReceiver('shipper',7)">{{ $t('SeaExport.Reset') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'shipperLine'+count"
            :class="'custom ' + getSenderAndReceiverColor('shipperLine',count)"
          >
            <cargo-input
              :ref="'shipperLine'+count"
              v-model="form['shipperLine'+count]"
              :disabled="readonly"
              :no="'shipperLine'+count"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              @dblclick.native="showSenderAndReceiverDialog('shipper',7, false, notUppercaseShipperConsigneNotify)"
              @change="()=>wrapAddr(form,'shipperLine'+count,count+1 > 7 ? null :'shipperLine'+(count+1),maxChars)"
            />
          </el-form-item>
          <el-form-item :label="$t('Message.Consignee')" class="custom">
            <div style="display: flex;">
              <el-input v-model="form.consigneeCode" :disabled="readonly" no="10" style="flex: 1" />
              <el-button no="11" :disabled="readonly" type="primary" style="margin-left: 5px" @click="clearSenderAndReceiver('consignee',7)">{{ $t('SeaExport.Reset') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'consigneeLine'+count"
            :class="'custom ' + getSenderAndReceiverColor('consigneeLine',count)"
          >
            <cargo-input
              :ref="'consigneeLine'+count"
              v-model="form['consigneeLine'+count]"
              :disabled="readonly"
              :no="'consigneeLine'+count"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              @dblclick.native="showSenderAndReceiverDialog('consignee',7,false, notUppercaseShipperConsigneNotify)"
              @change="()=>wrapAddr(form,'consigneeLine'+count,count+1 > 7 ? null :'consigneeLine'+(count+1),maxChars)"
            />
          </el-form-item>
          <el-form-item :label="$t('Message.Notify')" class="custom">
            <div style="display: flex;">
              <el-input v-model="form.notifyCode" :disabled="readonly" no="12" style="flex: 1;width: 100px" />
              <el-button no="13" :disabled="readonly" type="primary" style="margin-left: 5px" @click="clearSenderAndReceiver('notify',7)">{{ $t('SeaExport.Reset') }}</el-button>
              <el-button no="14" :disabled="readonly" type="primary" style="margin-left: 5px" @click="pm.onCopy_consignee()">{{ $t('SeaExport.CopyTheConsignee') }}</el-button>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'notifyLine'+count"
            :class="'custom ' + getSenderAndReceiverColor('notifyLine',count)"
          >
            <cargo-input
              :ref="'notifyLine'+count"
              v-model="form['notifyLine'+count]"
              :disabled="readonly"
              :no="'notifyLine'+count"
              :auto-uppercase="notUppercaseShipperConsigneNotify"
              :use-read-only="true"
              @dblclick.native="showSenderAndReceiverDialog('notify',7,false, notUppercaseShipperConsigneNotify)"
              @change="()=>wrapAddr(form,'notifyLine'+count,count+1 > 7 ? null :'notifyLine'+(count+1),maxChars)"
            />
          </el-form-item>
          <el-form-item label-width="0" class="custom">
            <div style="display: flex;">
              <span style="color:#404144">{{ $t('SeaExport.AgentInfo') }}</span>
              <div style="flex: 1;text-align: right">
                <el-button no="15" :disabled="readonly" type="primary" style="margin-right: 5px;" @click="clearSenderAndReceiver('agentParty',7)">{{ $t('SeaExport.Reset') }}</el-button>
                <el-dropdown
                  no="16"
                  :class="readonly?'not-click':''"
                  :disabled="readonly"
                  split-button
                  type="primary"
                  @click="commandHandle(command3)"
                  @command="p=>{command3=p;commandHandle(command3)}"
                >
                  {{ command3 }}
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item :command="$t('SeaExport.CopyMblConsignee')">{{ $t('SeaExport.CopyMblConsignee') }}</el-dropdown-item>
                    <el-dropdown-item :command="$t('SeaExport.CopyNominatedAgentInfo')">{{ $t('SeaExport.CopyNominatedAgentInfo') }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            v-for="count in 7"
            :key="'agentPartyLine'+count"
            :class="'custom ' + getSenderAndReceiverColor('agentPartyLine',count)"
          >
            <cargo-input
              :ref="'agentPartyLine'+count"
              v-model="form['agentPartyLine'+count]"
              :disabled="readonly"
              :no="'agentPartyLine'+count"
              :auto-uppercase="isUppercase"
              :use-read-only="true"
              @dblclick.native="showSenderAndReceiverDialog('agentParty',7,false)"
              @change="()=>wrapAddr(form,'agentPartyLine'+count,count+1 > 7 ? null :'agentPartyLine'+(count+1),maxChars)"
            />
          </el-form-item>
          <el-form-item label-width="0" class="custom">
            <span style="color:#404144">ALSO NOTIFY</span>
          </el-form-item>
          <el-form-item class="custom">
            <cargo-rich-textarea
              v-model="form.alsoNotify"
              no="17"
              :text-chars="maxChars"
              :warning-count="warningCount"
              :disabled="!isEdit"
              :use-read-only="true"
              style="height: 110px;"
              @dblclick.native="showAdvanceTextDialog('ALSO NOTIFY',form.alsoNotify,val=>{form.alsoNotify=val.toUpperCase()}, false, null, notUppercaseShipperConsigneNotify)"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="section form-column">
        <el-form :disabled="readonly" label-width="125px" label-position="right" style="height:100%">
          <span class="title">{{ $t('SeaExport.CargoInfo') }}</span>
          <el-form-item :label="$t('SeaExport.NumberOfPackagesOnBl')">
            <auto-number-input
              v-model="form.quantity"
              no="18"
              :precision="0"
              :min="0"
              @change="pm.quantity_Change()"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Package')" :class="variableCss.packing">
            <!-- <cargo-advance-select
              :select-type="selectTypeNames.basic_data_Packing"
              filterable
              :default-value="form.packing"
              style="width:100%;"
              @parentCallBack="p=>{pm.packing_Change(p)}"
            /> -->
            <cargo-packing-select
              no="19"
              :default-value="form.packing"
              @change="p => {pm.packing_Change(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Pieces2')" :class="variableCss.insideQuantity">
            <auto-number-input
              v-model="form.insideQuantity"
              no="20"
              :precision="0"
              :min="0"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PiecesType2')" :class="variableCss.insidePacking">
            <!-- <cargo-advance-select
              :select-type="selectTypeNames.basic_data_Packing"
              filterable
              :default-value="form.insidePacking"
              style="width:100%;"
              @parentCallBack="p=>{form.insidePacking=p.value}"
            /> -->
            <cargo-packing-select
              no="21"
              :default-value="form.insidePacking"
              @change="p => {form.insidePacking=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.GrossWeight')" :class="'custom '+variableCss.weight">
            <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
              <auto-number-input
                v-model="form.weight"
                no="22"
                :precision="3"
                :min="0"
              />
              <span>KGS</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Cubage')" :class="'custom '+variableCss.cubage">
            <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
              <auto-number-input
                v-model="form.cubage"
                no="23"
                :precision="3"
                :min="0"
              />
              <span>CBM</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ChargedWeightRT')" class="custom">
            <div class="form-item-input" :class="readonly ? 'input-disabled': ''">
              <auto-number-input
                v-model="form.chargeWeight"
                no="24"
                :precision="3"
                :min="0"
                @change="pm.txtChargeWeightHandler()"
              />
              <span>M/T</span>
            </div>
          </el-form-item>
          <el-form-item :label="$t('queryJob.englishDescriptionOfGoods')" :class="'label-none custom '+variableCss.cargoEnglishName">
            <cargo-rich-textarea
              v-model="form.cargoEnglishName"
              no="25"
              :disabled="!isEdit || textareaDisabled"
              :auto-uppercase="isUppercaseByConfig"
              style="height: 110px;"
              @dblclick.native="showAdvanceTextDialog($t('queryJob.englishDescriptionOfGoods'),form.cargoEnglishName,val=>{form.cargoEnglishName=val},false,null,isUppercaseByConfig , {
                warningCount: englishNameWarningCount,
                maxChar: englishNameMaxChars
              })"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.Marks')" :class="'label-none custom '+variableCss.mark">
            <cargo-rich-textarea
              v-model="form.mark"
              no="26"
              :disabled="!isEdit || textareaDisabled"
              :auto-uppercase="isUppercaseByConfig"
              style="height: 110px;"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.Marks'),form.mark,val=>{form.mark=val},false,null,isUppercaseByConfig , {
                warningCount: markWarningCount,
                maxChar: markMaxChars
              })"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CapitalizedNumbersOfPackages')" class="label-none custom">
            <el-input v-model="form.quantitySum" no="27" :disabled="true" />
          </el-form-item>
        </el-form>
      </div>
      <div class="section form-column">
        <el-form :disabled="readonly" label-width="100px" label-position="right" style="height:100%">
          <span class="title">{{ $t('SeaExport.TransportInfo') }}</span>
          <el-form-item label="HB/L NO2.">
            <el-input v-model="form.hblNbr2" no="28" />
          </el-form-item>
          <el-form-item :label="$t('Payment.warehouseNo')">
            <el-input v-model="form.warehouseNo" no="29" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.RelatedMbl')">
            <cargo-combo-box
              v-model="form.mblId"
              no="30"
              :disabled="readonly&&splitOrder.rowData.length>0"
              :options="pm.joinMBLs"
              label-field="mblNbr2"
              value-field="uuid"
              :need-old-value="true"
              :forbid-values="['']"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BillOfLadingNumber')">
            <el-input v-model="form.serialNo" no="31" />
          </el-form-item>
          <el-form-item :label="$t('Payment.vessel')">
            <cargo-advance-select
              no="32"
              :disabled="readonly||!pm._lclslaveEnabled"
              :select-type="selectTypeNames.basic_data_Vessel"
              filterable
              :allow-create="pm._allowEditingVessel"
              :default-value="job.vessel"
              style="width:100%;"
              @parentCallBack="p=>{pm.onVesselSelectionChange(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('Payment.voyage')">
            <el-select
              v-model="job.voyageFlight"
              no="33"
              :disabled="readonly||!pm._lclslaveEnabled"
              filterable
              :allow-create="pm.editVoyageMode===1"
              @focus="pm.txtVoyagefocusInHandler()"
              @blur="pm.txtVoyagefocusOutHandler()"
            >
              <el-option
                v-for="(item,index) in pm._voyages"
                :key="index"
                :label="item.voyageNo"
                :value="item.voyageNo"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('queryJob.dateOfDeparture')">
            <el-input no="34" :value="moment(job.etd).format('YYYY-MM-DD')" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DocDispatchingPlace')" :class="variableCss.dispatchingPlace">
            <el-input v-model="form.dispatchingPlace" no="35" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PortOfLoadingOnBl')" :class="variableCss.loadingPort">
            <el-input v-model="form.loadingPort" no="36" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PortOfDischargeOnBl')" :class="variableCss.dischargingPort">
            <el-input v-model="form.dischargingPort" no="37" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfDeliveryOnBl')" :class="variableCss.destinationPort">
            <el-input v-model="form.destinationPort" no="38" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.MethodOfHblPayment')">
            <cargo-advance-select
              no="39"
              :select-type="selectTypeNames.basic_data_PaymentTerm"
              filterable
              :default-value="form.paymentTerm"
              style="width:100%;"
              @parentCallBack="p=>{pm.paymentSelectHblChange(p)}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfHblPayment2')">
            <el-input v-model="form.paymentPlaceBL" no="40" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.TransportationClause')">
            <el-input v-model="job.freightTermHBL" no="41" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.NoOfOriginalBls')" :class="variableCss.blNumber">
            <el-input v-model="form.blNumber" no="42" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PlaceOfIssue')">
            <el-input v-model="form.signPlaceBL" no="43" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DateOfIssue')">
            <el-date-picker v-model="form.signDateBL" no="44" type="date" value-format="yyyy-MM-dd" style="width: 100%" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.BlRemarks')" :class="variableCss.remarks">
            <cargo-rich-textarea
              v-model="form.remarks"
              no="45"
              :disabled="!isEdit"
              :text-chars="maxChars"
              :warning-count="warningCount"
              style="height: 110px;"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.BlRemarks'),form.remarks,val=>{form.remarks=val})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.HsCode')">
            <el-input
              v-model="job.hsCode"
              no="46"
              type="textarea"
              :rows="5"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.HsCode'),job.hsCode,val=>{job.hsCode=val})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ReasonOfCargoDetention')">
            <el-input v-model="form.withholdReason" no="47" type="textarea" :rows="5" :disabled="true" />
          </el-form-item>
        </el-form>
      </div>
      <div class="section form-column">
        <el-form :disabled="readonly">
          <span class="title">{{ $t('SeaExport.OtherInfo') }}</span>
          <el-form-item
            v-show="job.typeHBL===BillType.SPLIT_BILL_TYPE.code"
            class="label-none custom"
          >
            <cargo-ag-grid
              no="48"
              :grid-options="splitOrder.gridOptions"
              :show-side-bar="false"
              :grid-params.sync="splitOrder.gridParams"
              :column-defs="splitOrder.columnDefs"
              :row-data="splitOrderFinalRowData"
              style="width:100%;height:200px"
              @gridReady="params=>{splitOrder.gridApi=params.api}"
            />
            <div style="padding:5px 0">
              <div style="float:right">
                <el-button ref="splitBtnAdd" no="49" type="primary" @click="pm.onAddCargoDoc2()">{{ $t('Payment.new') }}</el-button>
                <el-button no="50" type="danger" @click="pm.onRemoveCargoDoc()">{{ $t('FileHistory.Delete') }}</el-button>
              </div>
            </div>
          </el-form-item>
          <el-form-item
            v-show="job.typeHBL===BillType.MERGE_BILL_TYPE.code"
            class="label-none custom"
          >
            <cargo-ag-grid
              no="51"
              :grid-options="mergeOrder.gridOptions"
              :grid-params.sync="mergeOrder.gridParams"
              :column-defs="mergeOrder.columnDefs"
              :row-data="mergeOrderFinalRowData"
              :show-side-bar="false"
              style="width:100%;height:200px"
              @gridReady="params=>{mergeOrder.gridApi=params.api}"
            />
            <div style="padding:5px 0">
              <div style="float:right">
                <el-button no="52" type="primary" @click="pm.onMergeAddJob()">{{ $t('SeaExport.Add3') }}</el-button>
                <el-button no="53" type="danger" @click="pm.onMergeRemoveJob()">{{ $t('FileHistory.Delete') }}</el-button>
              </div>
            </div>
          </el-form-item>
        </el-form>
        <el-form :disabled="readonly" label-position="right" label-width="100px" style="height:100%">
          <el-form-item :label="$t('SeaExport.BlType')">
            <el-select
              no="54"
              :value="form.releaseType||''"
              @input="val=>{form.releaseType=val}"
              @change="val=>{pm.cmbreleaseTypeMBLChangeHandler(val)}"
            >
              <el-option
                v-for="(item,index) in blModeList"
                :key="index"
                :label="item.name"
                :value="item.serialNumber"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CheckingStatus')" class="red">
            <el-input no="55" :value="lblCfrState" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ReleasingStatus')" class="red">
            <el-input no="56" :value="lblReleaseState" :disabled="true" />
          </el-form-item>
          <el-form-item>
            <el-checkbox
              no="57"
              :value="form.releaseReview===1"
              :disabled="true"
              style="margin-right: 6px;"
            >{{ $t('SeaExport.DataSent') }}</el-checkbox>
            <el-checkbox no="58" :value="form.payable" :disabled="true" style="margin-right: 6px;">{{ $t('CargoMsg.Cargo_Completed') }}</el-checkbox>
            <el-checkbox no="59" :value="form.withhold" :disabled="true" style="margin-right: 0px;">{{ $t('SeaExport.CargoDetention') }}</el-checkbox>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.PaymentDate2')">
            <el-date-picker
              v-model="form.agreePayDate"
              no="60"
              :disabled="true"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.DateOfCargoDetention')">
            <el-date-picker
              v-model="form.withholdDate"
              no="61"
              :disabled="true"
              type="date"
              value-format="yyyy-MM-dd"
              style="width: 100%"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ParamRemark')">
            <el-select v-model="form.printParam4" no="62" filterable allow-create>
              <el-option
                v-for="(item,index) in pm.printParam4Type"
                :key="index"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.GenerationOfABillOfLading2')">
            <el-select v-model="form.printParam5" no="63">
              <el-option
                v-for="(item,index) in pm.printParam5Type"
                :key="index"
                :label="item.label"
                :value="item.data"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ContainerAmount')">
            <el-input
              v-model="form.seaeq"
              no="64"
              type="textarea"
              :rows="5"
              style="width:100%"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.ContainerAmount'),form.seaeq,val=>{form.seaeq=val})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.CNTRNOSSEALNOS')">
            <el-input
              v-model="form.container"
              no="65"
              type="textarea"
              :rows="5"
              style="width:100%"
              @dblclick.native="showAdvanceTextDialog($t('SeaExport.CNTRNOSSEALNOS'),form.container,val=>{form.container=val})"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ShippingCompanySCAC')">
            <el-input no="66" :value="job.carrierScac || txtCarrierScAc" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.OverseasAgentSCAC')">
            <el-input no="67" :value="txtBookingAgentScAc" :disabled="true" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ShipperContactTelNo')">
            <el-input v-model="form.shipperTel" no="68" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ConsigneeContactTelNo')">
            <el-input v-model="form.consigneeTel" no="69" />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.NotifyPartyTelNo')">
            <el-input v-model="form.notifyTel" no="50" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      no="51"
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        ref="advanceTextDialogTextarea"
        v-model="advanceTextDialog.value"
        :auto-uppercase="advanceTextDialog.isUppercase"
        :disabled="!isEdit"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" no="52" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="53"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
    <!-- 收发通地址弹窗 -->
    <bill-address-dialog :visible.sync="billAddressDialog.visible" :job="billAddressDialog.job" :params="billAddressDialog.params" @callback="codeSearchCallback" />
    <!-- 工作单检索弹窗 -->
    <job-no-transcribe-dialog
      v-if="searchJobNoDialog.visible"
      :visible.sync="searchJobNoDialog.visible"
      lob="SI"
      :params="searchJobNoDialog.params"
      @selected="searchJobNoDialog.selectHandler"
    />
    <!-- 抄录弹窗 -->
    <transcribe-dialog :visible.sync="transcribeDialog.visible" :job="job" @callback="transcribeCallback" />
    <!-- 反恐地址格式化弹窗 -->
    <address-format-dialog
      :visible.sync="addressFormatDialog.visible"
      :params="addressFormatDialog.params"
    />
    <!-- 打印报表对话框 -->
    <cargo-template-selector-dialog
      :visible.sync="templateSelectorDialog.visible"
      :ctx="templateSelectorDialog.ctx"
      :category="templateSelectorDialog.category"
      :data="templateSelectorDialog.data"
      :context="context"
      :pre-print-callback="prePrintCallback"
      :printed-callback="printedCallback"
      :v2-check-callback="v2CheckCallback"
    />
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      no="54"
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('Payment.chargeItem')">
            <cargo-advance-select
              no="55"
              :select-type="selectTypeNames.basic_data_ChargeItem"
              filterable
              :default-value="editDialog.form.chargeItemId||''"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.chargeItemId=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ChargeClause')">
            <cargo-advance-select
              no="56"
              :select-type="selectTypeNames.basic_data_PaymentTerm"
              filterable
              :default-value="editDialog.form.paymentTermHBL"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.paymentTermHBL=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('Message.CurrencyExchangeRateIsNotMaintained1')">
            <cargo-advance-select
              no="57"
              :select-type="selectTypeNames.basic_data_Currency"
              filterable
              :default-value="editDialog.form.currency"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.currency=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ContainerSize')">
            <cargo-advance-select
              no="58"
              :select-type="selectTypeNames.local_cache_EQSize"
              filterable
              :default-value="editDialog.form.eqSize"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.eqSize=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('SeaExport.ContainerType')">
            <cargo-advance-select
              no="59"
              :select-type="selectTypeNames.basic_data_EQType"
              filterable
              :default-value="editDialog.form.eqType"
              style="width:100%;"
              @parentCallBack="p=>{editDialog.form.eqType=p.value}"
            />
          </el-form-item>
          <el-form-item :label="$t('Payment.quantity')">
            <el-input-number
              v-model="editDialog.form.quantity"
              no="60"
              :precision="0"
              :controls="false"
              style="width:100%"
              @change="caculateAmount"
            />
          </el-form-item>
          <el-form-item :label="$t('Payment.unitPrice')">
            <el-input-number
              v-model="editDialog.form.unitRate"
              no="61"
              :precision="2"
              :controls="false"
              style="width:100%"
              @change="caculateAmount"
            />
          </el-form-item>
          <el-form-item :label="$t('Payment.amount')">
            <el-input-number
              v-model="editDialog.form.amount"
              no="62"
              :precision="2"
              :controls="false"
              style="width:100%"
              @change="editDialog.form.unitRate=editDialog.form.amount"
            />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="63" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="64" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TabHBL2PM } from './tabHBL2PM'

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import cargoInput from '@/components/Cargo/Common/cargoInput'
import billAddressDialog from '@/components/Cargo/Job/billAddressDialog'
import emailInput from '@/components/Cargo/Job/emailInput'
import transcribeDialog from '@/components/Cargo/Job/transcribeDialog'
import addressFormatDialog from '@/views/cargo/v0/SeaExport/components/edi/addressFormatDialog'
import cargoTemplateSelectorDialog from '@/components/Cargo/Common/cargoTemplateSelectorDialog'
import cargoPackingSelect from '@/components/Cargo/Common/cargoPackingSelect'
import moment from 'moment'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import * as NumberUtils from '@/utils/NumberUtils'
import { AutoIncrementNum } from '@/utils/commonUtil'
import * as BillType from '@/class/cargo/model/parameters/BillType'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { CargoDocUtil } from '@/class/cargo/model/utils/CargoDocUtil'
import { SeaImCargoDoc } from '@/class/model/booking/SeaImCargoDoc'
import { FreightCharges } from '@/class/model/booking/FreightCharges'
import jobNoTranscribeDialog from '@/components/Cargo/Job/jobNoTranscribeDialog'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import SenderAndReceiver from '@/mixin/SenderAndReceiver'
import cargoComboBox from '@/components/Cargo/Common/cargoComboBox'
import AutoNumberInput from '@/components/Cargo/Common/AutoNumberInput'
import { getLoading } from '@/utils/utilBaseElement'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { SeaImportJob } from '@/class/model/booking/SeaImportJob'

export default {
  name: 'TabHbl2',
  components: {
    cargoAdvanceSelect, AutoNumberInput, cargoPackingSelect, cargoInput, billAddressDialog, jobNoTranscribeDialog, emailInput, cargoRichTextarea,
    transcribeDialog, addressFormatDialog, cargoTemplateSelectorDialog, cargoComboBox
  },
  mixins: [SenderAndReceiver],
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      maxChars: 0,
      warningCount: -1,
      englishNameMaxChars: 0,
      markMaxChars: 0,
      englishNameWarningCount: -1,
      markWarningCount: -1,
      textareaDisabled: false, // 英文名称、唛头文本框只读控制
      visible: false, // 先隐藏，避免组件在初始化完成前，做一些无效的处理（频繁刷新组件、调用接口等）
      pm: new TabHBL2PM(this),
      addrPM: null, // 提单
      moment,
      BillType,
      CargoDocConsts,
      NumberUtils,
      CargoDocUtil,
      selectTypeNames: TYPE_NAMES,
      partnerManagementMode: 0,
      mergeHblData: false,
      btnPrintDisabled: true,
      hblNoDisabled: false,
      isUppercase: true,
      blModeList: [
        { serialNumber: 1, code: 'ORIGINAL', name: 'ORIGINAL', localName: '正本' },
        { serialNumber: 2, code: 'SURRENDERED', name: 'SURRENDERED', localName: '电放' },
        { serialNumber: 3, code: 'SEA WAYBILL', name: 'SEA WAYBILL', localName: '电放' }
      ],
      otherFieldsData: [],
      job: {},
      form: new SeaImCargoDoc().fillDefaultValue().getData(),
      chkConsolidationClosed: false,
      otherSelectField: '',
      otherCode: '',
      lblCfrState: '',
      lblReleaseState: '',
      txtCarrierScAc: '',
      txtBookingAgentScAc: '',
      command1: this.$t('SeaExport.CodeSearching'),
      command3: this.$t('SeaExport.CopyMblConsignee'),
      variableCss: {
        shipperLine1: '', // 发货人1
        shipperLine2: '', // 发货人2
        shipperLine3: '', // 发货人3
        shipperLine4: '', // 发货人4
        shipperLine5: '', // 发货人5
        shipperLine6: '', // 发货人6
        consigneeLine1: '', // 收货人1
        consigneeLine2: '', // 收货人2
        consigneeLine3: '', // 收货人3
        consigneeLine4: '', // 收货人4
        consigneeLine5: '', // 收货人5
        consigneeLine6: '', // 收货人6
        notifyLine1: '', // 通知人1
        notifyLine2: '', // 通知人2
        notifyLine3: '', // 通知人3
        notifyLine4: '', // 通知人4
        notifyLine5: '', // 通知人5
        notifyLine6: '', // 通知人6
        agentPartyLine1: '', // 代理信息1
        agentPartyLine2: '', // 代理信息2
        agentPartyLine3: '', // 代理信息3
        agentPartyLine4: '', // 代理信息4
        agentPartyLine5: '', // 代理信息5
        agentPartyLine6: '', // 代理信息6
        blNumber: '', // 提单份数
        packing: '', // 包装
        insideQuantity: '', // 小件数
        insidePacking: '', // 小件数包装类型
        dispatchingPlace: '', // (提单发货地)发货地
        weight: '', // 提单毛重
        cubage: '', // 提单体积
        loadingPort: '', // (提单起运港)装货港
        dischargingPort: '', // (提单卸货港)中转港
        destinationPort: '', // (提单交货地)目的港
        cargoEnglishName: '', // 英文品名
        mark: '', // 唛头
        remarks: ''// 备注
      },
      // 拆单
      splitOrder: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          context: {
            componentParent: this
          },
          onRowClicked: event => { this.pm.onSplitSelectionChange(event) }
        },
        columnDefs: [
          {
            headerName: this.$t('SeaExport.HblNo2'),
            suppressMenu: true,
            field: 'hblNbr2',
            width: 130
          }
        ],
        rowData: [],
        gridApi: null
      },
      // 并单
      mergeOrder: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          suppressRowClickSelection: false,
          context: {
            componentParent: this
          }
        },
        columnDefs: [
          {
            headerName: this.$t('Payment.businessNumber'),
            colId: 'jobNo',
            field: 'jobNo',
            width: 115
          },
          {
            headerName: this.$t('SeaExport.Quantity'),
            colId: 'quantityActual',
            field: 'quantityActual',
            width: 85
          },
          {
            headerName: this.$t('SeaExport.Weight'),
            colId: 'weightActual',
            field: 'weightActual',
            width: 85
          },
          {
            headerName: this.$t('SeaExport.Cubage'),
            colId: 'cubageActual',
            field: 'cubageActual',
            width: 85
          }
        ],
        rowData: [],
        gridApi: null
      },
      autoIncrementNum: new AutoIncrementNum(),
      billAddressDialog: {
        visible: false
      },
      searchJobNoDialog: {
        visible: false,
        params: {},
        selectHandler: () => {
        }
      },
      emailInput: {
        visible: false,
        emailTitle: '',
        emailContent: '',
        fileIdList: ''
      },
      transcribeDialog: {
        visible: false
      },
      // 反恐舱单-反恐地址格式化-弹窗
      addressFormatDialog: {
        visible: false,
        params: { cargoDocs: [] }
      },
      templateSelectorDialog: {
        visible: false,
        ctx: new SeaImCargoDoc(),
        category: '',
        data: {}
      },
      prePrintCallback: null,
      printedCallback: null,
      v2CheckCallback: null,
      lob: 'SI',
      editDialog: {
        visible: false,
        title: '',
        form: new FreightCharges().fillDefaultValue().getData()
      },
      addJoinMergeJobList: [], // 当前添加的并单（未保存）
      notUppercaseShipperConsigneNotify: true, // CARGO-47047 收发通大小写控制
      isUppercaseByConfig: true // CARGO-49117 是否大写
    }
  },
  computed: {
    readonly() {
      return !this.isEdit
    },
    isEdit() {
      if (!this.cooperateEdit) return false
      return this.action !== 'look' && (!this.form.uuid || this.form.state < 2)
    },
    btnBLConfirmDisabled() {
      return this.isEdit || !this.form.uuid
    },
    config() {
      return this.context.config
    },
    user() {
      return this.context.user
    },
    splitOrderFinalRowData() {
      return this.splitOrder.rowData.filter(p => !p.deleted).sort((a, b) => {
        const suffixA = a.hblNbr2.replace(`${this.job.jobNo}-`, '')
        const suffixB = b.hblNbr2.replace(`${this.job.jobNo}-`, '')
        return suffixA - suffixB
      })
    },
    mergeOrderFinalRowData() {
      return this.mergeOrder.rowData.filter(p => !p.deleted)
    }
  },
  watch: {
    // job上的 约价方式修改 影响 hbl 上的船名控件
    'job.bookingTerm': {
      handler: function(val) {
        this.pm.editInputVesselModel()
      }
    }
  },
  async created() {
    const loading = getLoading()
    this.context.loading = true
    await this.context.prepareData()
    this.partnerManagementMode = Number(this.config.get('PartnerManagementMode')) // 是否启用合作伙伴管理模式
    this.synchronousShipperCodeAndConsigneeCodeAndNotifyCode = Number(this.config.get('synchronousShipperCodeAndConsigneeCodeAndNotifyCode')) === 1
    this.notUppercaseShipperConsigneNotify = Number(this.config.get('NotUppercaseShipperConsigneNotify')) !== 1
    this.isUppercaseByConfig = Number(this.config.get('autoUppercaseEnabled')) === 0 // CARGO-49117 英文品名、唛头可以支持小写字 为0就大写 1可以大写可以小写
    this.pm.init()
    this.visible = true
    loading.close()
    this.context.loading = false
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.addJoinMergeJobList = []
      this.job = row
      this.chkConsolidationClosed = false
      this.pm.changeJob()
      await this.pm.display()
      await this.pm.fillView()
    },
    async getSubmitData() {
      this.pm.validateForm()
      await this.pm.fillModel()
      let seaCargoDoc = null
      if (this.job.typeHBL === BillType.SPLIT_BILL_TYPE.code) {
        seaCargoDoc = this.splitOrder.rowData
      } else {
        seaCargoDoc = [this.form]
      }
      const afrAddressList = []
      for (const cargoDoc of seaCargoDoc) {
        if (cargoDoc.afrAddress && cargoDoc.afrAddress.length > 0) { afrAddressList.push(cargoDoc.afrAddress[0]) }
      }
      return {
        seaCargoDoc,
        // afrAddressList: afrAddressList, 跟随doc 保存数据
        hblJoinMergeJobList: this.addJoinMergeJobList,
        job: { ...this.job }
      }
    },
    executeTask() {
      this.pm.executeTask()
    },
    commandHandle(command) {
      switch (command) {
        case this.$t('SeaExport.CodeSearching'):
          this.billAddressDialog.visible = true
          this.billAddressDialog.params = this.form
          this.billAddressDialog.job = this.job
          break
        case this.$t('SeaExport.CopyFromTheLastTime'):
          this.pm.onCopy1()
          break
        case this.$t('SeaExport.CopyFromOtherBill'):
          this.job.key = this.job.uuid
          Object.assign(this.searchJobNoDialog.params, {
            selectType: 'single',
            docType: this.form.docType,
            job: this.job
          })
          this.searchJobNoDialog.selectHandler = p => {
            this.pm.selectionItemHandler(p)
          }
          this.searchJobNoDialog.visible = true
          break
        case this.$t('SeaExport.CopyCargoDescriptionAndMarks'):
          this.transcribeDialog.visible = true
          break
        case this.$t('SeaExport.CopyMblConsignee'):
          this.pm.onCopy_agentParty()
          break
        case this.$t('SeaExport.CopyNominatedAgentInfo'):
          this.pm.onCopy_designationAgent()
          break
      }
    },
    codeSearchCallback(data) {
      if (data.shipperInfo) {
        this.splitSenderAndReceiverLine('shipper', 7, data.shipperInfo)
      }
      if (data.consigneeInfo) {
        this.splitSenderAndReceiverLine('consignee', 7, data.consigneeInfo)
      }
      if (data.notifyInfo) {
        this.splitSenderAndReceiverLine('notify', 7, data.notifyInfo)
      }
      if (data.hasOwnProperty('shipperCode')) {
        this.form['shipperCode'] = data.shipperCode || ''
      }
      if (data.hasOwnProperty('consigneeCode')) {
        this.form['consigneeCode'] = data.consigneeCode || ''
      }
      if (data.hasOwnProperty('notifyCode')) {
        this.form['notifyCode'] = data.notifyCode || ''
      }
    },
    transcribeCallback(data) {
      if (data.hasOwnProperty('cargoEnglishName')) {
        this.form.cargoEnglishName = data.cargoEnglishName
      }
      if (data.hasOwnProperty('mark')) {
        this.form.mark = data.mark
      }
    },
    /**
     * 正本打印
     */
    originalPrint() {
      if (this.pm.originalPrintCheckSerialNo && this.form.releaseType === 1 && !this.form.serialNo) {
        this.$message.info(this.$t('Message.PleaseEnterTheBillOfLadingSerialNumber'))
        return
      }
      const params = {}
      params.cargoDocUuid = this.form.uuid
      params.fileAliasName = this.form.hblNbr2
      params.DOC_UUID = this.form.uuid
      // CARGO-6750，SOP回调cargo失败。UUID中有 /导致url匹配不上了
      params.printCallBackUrl = 'services/printExec/entity/update2/CargoDoc?key=' + encodeURIComponent(this.form.uuid) + '&fieldCount=1&field1=state&value1=2'
      this.templateSelectorDialog.ctx = new SeaImCargoDoc(this.form)
      this.templateSelectorDialog.category = this.form.releaseType === 1 ? 'SIHBL2ZB' : 'SIHBL2DF'
      this.templateSelectorDialog.data = params
      // 组装打印回调函数
      this.prePrintCallback = null
      this.printedCallback = event => {
        this.pm.print_callback()
      }
      this.v2CheckCallback = (isSure, template, entity, arms) => {
        this.pm.v2CheckCallbackFun2(isSure, template, entity, arms)
      }
      this.templateSelectorDialog.visible = true
    },
    showAddressFormatDialog() {
      this.addressFormatDialog.params = { cargoDocs: [this.form] }
      this.addressFormatDialog.visible = true
    },
    caculateAmount() {
      const form = this.editDialog.form
      form.amount = (form.quantity || 0) * (form.unitRate || 0)
    },
    save() {
      const form = this.editDialog.form
      if (!form.seq) {
        this.rowData.push(form)
      } else {
        const row = this.rowData.find(p => p.seq === form.seq)
        if (row) {
          Object.assign(row, form)
          this.gridApi.refreshCells({ force: true })
        }
      }
      this.editDialog.visible = false
    },
    async endTabHandler() { // 切换页签调用的方法
      await this.pm.fillModel()
    },
    // 组装打印参数
    getPrintData() {
      if (!this.form || !this.form.uuid) {
        this.$message.warning(this.$t('Message.NoSelectedCargoDocInformation'))
        return
      }
      const params = {}
      params.jobuuid = this.job.uuid
      params.cargoDocUuid = this.form.uuid
      params.fileAliasName = this.form.hblNbr2
      params.DOC_UUID = this.form.uuid
      params.category = 'SIHBL2'
      params.ctx = new SeaImportJob(this.job)
      params.v2CheckCallback = null
      return params
    }
  }
}
</script>

<style lang="scss" scoped>
.form-column{
  .form-item-input{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    background-color: #fff;
    border: 1px solid #E4E7ED;
    span{
      width: 40px;
      height: 28px;
      line-height: 26px;
      box-sizing: border-box;
      padding-left: 5px;
      padding-top: 1px;
    }
    /deep/.el-input {
      width: 86%;
      input{
        border: 0;
        padding-right: 0 !important;
        text-align: right;
      }
    }
  }
  .input-disabled{
    background-color: #f0f3f8 !important;
    cursor: not-allowed;
  }
}
</style>
